import { render } from "./PesanAktif.vue?vue&type=template&id=3f7f3b62"
import script from "./PesanAktif.vue?vue&type=script&lang=js"
export * from "./PesanAktif.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__